import type { FaireProductEntity } from "../../entity_types/product";

export const p_xbgateqs35: FaireProductEntity = {
  token: "p_xbgateqs35",
  type: "product",
  name: "Scarf - but isn’t everything we do in life a way to be loved a little more’",
  brandToken: "b_8zb3ehhn27",
  brandName: "ohimgood",
  imageUrl: "https://cdn.faire.com/fastly/4d7dbb30514dc12ef72eeb5b20fe366a587445f7371afdedbcd436b85ebba59c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1de523d80b321a145aec747cc610ac57cac9e204b36769d45a439944186262b.jpeg"
  ],
  priceDollars: 17.5,
  description: "But isn’t everything we do in life a way to be loved a little more’ \n\n\nPRODUCT — Vegan Scarf\nSIZE — 50 x 50 cm\nCARE — Hand wash only\n\n\nIt’s a everything scarf that could be used as a scarf, headband, bag accessory, cover or wall art:)\n\nMore information on shipping & returns in the FAQ section.\n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:41.034Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
